angular.module 'app'
.controller 'WebsiteSetLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->

  $scope.permission = Storage.get('user_permission')
